import { Translation } from '../../domain/Translation';

export const translate = (translations: Translation[], alias: string) => {
  return (
    translations.find((translation) => translation.alias === alias)?.value ??
    alias
  );
};
